<h3 class="mt-3">Captured Fields</h3>
<nz-table [nzBordered]="true" [nzFrontPagination]="false" [nzData]="questions">
	<thead>
		<tr>
			<th>Question</th>
			<th *ngFor="let questionnaire of ticket.questionnaires">{{questionnaire.name}}</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let question of questions">
			<td>{{question.title}}</td>
			<td *ngFor="let answer of question.answers">{{answer}}</td>
		</tr>
	</tbody>
</nz-table>
